module.exports = __webpack_public_path__ + "img/culture_title.8427c081.png";